// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2eZTC","content":"styles_content__JCHGW"};